module.exports = __webpack_public_path__ + "static/media/Classic-preview.6caf229b.jpg";